import { createAnimation, IonLoading } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import PartnershipRepository from '../../repositories/PartnershipRepository';

interface Theme {
  id: string;
  logo: string;
  favicon?: string;
  colors?: {
    primary?: {
      base?: string;
      lighter?: string;
      darker?: string;
    };
    secondary?: {
      base?: string;
      lighter?: string;
      darker?: string;
    };
  };
  home: {
    type: 'default' | 'covidRegistration';
    welcomeText?: string;
    bodyText?: string;
  };
  laboratorySelection?: {
    intro?: string;
    title?: string;
  };
}

const DEFAULT_THEME: Theme = {
  id: 'default',
  logo: require('../../assets/images/logo-unilabs.svg'),
  home: {
    type: 'default'
  }
};

export const ThemeContext = React.createContext<Theme>(DEFAULT_THEME);

const GetStyle = (theme: Theme) => {
  return `
  :root {
    /** primary **/
    --ion-color-primary: ${theme.colors?.primary?.base ?? '#f09600'};
    --ion-color-primary-rgb: 240, 150, 0;
    --ion-color-primary-contrast: #ffffff;
    --ion-color-primary-contrast-rgb: 255, 255, 255;
    --ion-color-primary-shade: ${theme.colors?.primary?.darker ?? '#c27b00'};
    --ion-color-primary-tint: ${theme.colors?.primary?.lighter ?? '#ffc868'};
  
    /** secondary **/
    --ion-color-secondary: ${theme.colors?.secondary?.base ?? '#de3c20'};
    --ion-color-secondary-rgb: 222, 60, 32;
    --ion-color-secondary-contrast: #ffffff;
    --ion-color-secondary-contrast-rgb: 255, 255, 255;
    --ion-color-secondary-shade: ${
      theme.colors?.secondary?.darker ?? '#de3c20'
    };
    --ion-color-secondary-tint: ${
      theme.colors?.secondary?.lighter ?? '#de3c20'
    };
    }
  }
  }
  `;
};

const ThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(DEFAULT_THEME);
  const [loading, setLoading] = useState(true);

  // Init manual theme updates
  useEffect(() => {
    if (theme.favicon) {
      const favicon = document.getElementById('favicon') as HTMLLinkElement;

      if (favicon) {
        favicon.href = theme.favicon;
      }
    }
  }, [theme]);

  // Load theme data from API
  useEffect(() => {
    setLoading(true);
    const host = window.location.hostname;
    // const host = 'unilabs-front-accor.wow-digital.com';
    Promise.all([
      PartnershipRepository.getByHost(host).then((theme) => {
        if (theme) {
          setTheme(theme);
        }
      }),
      new Promise((resolve) => setTimeout(() => resolve(true), 500))
    ]).finally(() => {
      setLoading(false);
    });
  }, []);

  return (
    <ThemeContext.Provider value={theme}>
      <style
        dangerouslySetInnerHTML={{
          __html: GetStyle(theme)
        }}
      />
      <IonLoading
        isOpen={loading}
        cssClass="opaque-backdrop"
        enterAnimation={(baseEl) =>
          createAnimation()
            .addElement(baseEl.querySelector('.loading-wrapper'))
            .fromTo('opacity', '1', '1')
        }
        leaveAnimation={(baseEl) =>
          createAnimation()
            .addElement(baseEl)
            .duration(200)
            .fromTo('opacity', '1', '0')
        }
      />
      {!loading ? children : null}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
